import React from 'react';
import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';

const Terms = () => {
  const { t } = useTranslation();

  return (
    <div className="min-h-screen py-12">
      <div className="container mx-auto px-4 max-w-4xl">
        <motion.div initial={{ opacity: 0, y: 12 }} animate={{ opacity: 1, y: 0 }} className="card p-6 sm:p-10 space-y-6">
          <h1 className="text-3xl font-bold text-gray-900 dark:text-white">{t('terms.title', 'Terms & Conditions')}</h1>

          <section className="space-y-3 text-gray-700 dark:text-gray-300 text-sm sm:text-base leading-relaxed">
            <p>{t('terms.intro')}</p>

            <h2 className="text-xl font-semibold text-gray-900 dark:text-white">{t('terms.account_title')}</h2>
            <ul className="list-disc pl-6 space-y-2">
              <li>{t('terms.account_1')}</li>
              <li>{t('terms.account_2')}</li>
              <li>{t('terms.account_3')}</li>
            </ul>

            <h2 className="text-xl font-semibold text-gray-900 dark:text-white">{t('terms.login_title')}</h2>
            <ul className="list-disc pl-6 space-y-2">
              <li>{t('terms.login_1')}</li>
              <li>{t('terms.login_2')}</li>
            </ul>

            <h2 className="text-xl font-semibold text-gray-900 dark:text-white">{t('terms.rewards_title')}</h2>
            <ul className="list-disc pl-6 space-y-2">
              <li>{t('terms.rewards_1')}</li>
              <li>{t('terms.rewards_2')}</li>
              <li>{t('terms.rewards_3')}</li>
              <li>{t('terms.rewards_4')}</li>
            </ul>

            <h2 className="text-xl font-semibold text-gray-900 dark:text-white">{t('terms.refund_title')}</h2>
            <ul className="list-disc pl-6 space-y-2">
              <li>{t('terms.refund_1')}</li>
              <li>{t('terms.refund_2')}</li>
              <li>{t('terms.refund_3')}</li>
              <li>{t('terms.refund_4')}</li>
              <li>{t('terms.refund_5')}</li>
            </ul>

            <h2 className="text-xl font-semibold text-gray-900 dark:text-white">{t('terms.content_title')}</h2>
            <ul className="list-disc pl-6 space-y-2">
              <li>{t('terms.content_1')}</li>
              <li>{t('terms.content_2')}</li>
              <li>{t('terms.content_3')}</li>
            </ul>

            <p>{t('terms.footer')}</p>
          </section>
        </motion.div>
      </div>
    </div>
  );
};

export default Terms;
